import angular from 'angular';

import '../../core/main/controller/environment';

angular.module("merchant.application.main").factory("merchant.application.main.factory.invoicingEmail", [
    "$resource",
    "core.application.main.controller.environment",
    function($resource, Environment) {

        var resourceCreateList = $resource(Environment.MERCHANT_PORTAL_API_BASE_URL + "/portal/merchants/:merchantId/invoice-email");
        var resourceDelete = $resource(Environment.MERCHANT_PORTAL_API_BASE_URL + "/portal/merchants/:merchantId/invoice-email/:id");

        var expose = {};

        expose.populate = function(parameters, success, error) {
            resourceCreateList.get(parameters, success, error);
        };

        expose.create = function(parameters, success, error) {
            var urlParams = {
                merchantId: parameters.merchantId
            };
            new resourceCreateList(parameters).$save(urlParams, success, error);
        };

        expose.delete = function(parameters, success, error) {
            resourceDelete.delete({
                id: parameters.id,
                merchantId: parameters.merchantId
            }, success, error);
        };

        return expose;
    }
]);
